export const SET_SESSION = 'browserTypes/SET_SESSION';
export const SET_LOADING = 'sessionTypes/SET_LOADING';
export const UPDATE_AUTHORIZATION = 'sessionTypes/UPDATE_AUTHORIZATION';
